import React from "react";
import { Button, Modal } from "antd";

const TimeTrackerIdleModal = ({
  open,
  onConfirm,
  onPause,
  onCheckOut,
  onClose,
  confirmLoading = false,
  pauseLoading = false,
  checkoutLoading = false,
}) => (
  <Modal
    title="Inactivity Detected"
    open={open}
    onCancel={onClose}
    footer={[
      <Button key="close" onClick={onClose}>
        Close
      </Button>,
      <Button key="pause" loading={pauseLoading} onClick={onPause}>
        Pause
      </Button>,
      <Button
        key="checkout"
        danger
        loading={checkoutLoading}
        onClick={onCheckOut}
      >
        Check Out
      </Button>,
      <Button
        key="confirm"
        type="primary"
        loading={confirmLoading}
        onClick={onConfirm}
      >
        Yes, I&apos;m here
      </Button>,
    ]}
    maskClosable={false}
    closable
  >
    <p className="mb-0">No activity detected. Are you still here?</p>
    <p className="text-sm text-gray-500 mt-2 mb-0">
      Your session will be automatically paused if there is no response within 2 minutes.
      Use Resume on the Time Tracker page to continue from where you left off.
    </p>
  </Modal>
);

export default TimeTrackerIdleModal;
